import useAuth from 'hooks/useAuth';
import { useQuery } from 'react-query';

export default function useIntakeForm(userId: string) {
  const { request } = useAuth();
  const url = `/user/${userId}/documents/intake-form`;

  const { data: intakeForm, refetch: refetchIntakeForm } = useQuery(url, () => request.get(url).then((r) => r.data.data as IntakeForm));

  return { intakeForm, refetchIntakeForm };
}

export interface TreatmentHistory {
  treatmentHistory_1: string;
  treatmentHistory_2: string;
  treatmentHistory_3: string;
  treatmentHistory_2_1: string;
  treatmentHistory_3_1: string;
  treatmentHistory_3_2: string;
}

export interface MentalHealthHistory {
  mentalHealthHistory_2: string;
  mentalHealthHistory_4: string;
  mentalHealthHistory_5: string;
  mentalHealthHistory_6: string;
  mentalHealthHistory_7: string;
  mentalHealthHistory_1: string;
  mentalHealthHistory_4_1: string;
  mentalHealthHistory_5_1: string;
  mentalHealthHistory_6_1: string;
  mentalHealthHistory_3_3: string;
  mentalHealthHistory_3_1: string;
  mentalHealthHistory_3_2: string;
  mentalHealthHistory_3_4: string;
  mentalHealthHistory_3_5: string;
  mentalHealthHistory_3_6: string;
  mentalHealthHistory_3_7: string;
  mentalHealthHistory_3_8: string;
  mentalHealthHistory_3_9: string;
  mentalHealthHistory_3_10: string;
  mentalHealthHistory_3_11: string;
  mentalHealthHistory_3_12: string;
  mentalHealthHistory_3_13: string;
  mentalHealthHistory_3_14: string;
  mentalHealthHistory_3_15: string;
  mentalHealthHistory_3_16: string;
  mentalHealthHistory_3_17: string;
  mentalHealthHistory_3_18: string;
}

export interface SocialHistory {
  socialHistory_1: string;
  socialHistory_2: string;
  socialHistory_3: string;
  socialHistory_4: string;
  socialHistory_5: string;
  socialHistory_6: string;
  socialHistory_7: string;
  socialHistory_6_2: string;
  socialHistory_6_1: string;
  socialHistory_8: string;
  socialHistory_9: string;
  socialHistory_10: string;
  socialHistory_11: string;
  socialHistory_12: string;
  socialHistory_13: string;
  socialHistory_14: number;
  socialHistory_15: string;
}

export interface LegalHistory {}

export interface EducationalHistory {
  educationalHistory_1: string;
  educationalHistory_2: string;
  educationalHistory_3: string;
  educationalHistory_4: string;
  educationalHistory_5: string;
  educationalHistory_6: string;
}

export interface OccupationalInfo {
  occupationalInfo_1: string;
  occupationalInfo_2: string;
  occupationalInfo_3: string;
  occupationalInfo_4: string;
  occupationalInfo_5: string;
  occupationalInfo_6: string;
  occupationalInfo_7: string;
  occupationalInfo_8: string;
  occupationalInfo_9: string;
  occupationalInfo_10: string;
}

export interface ReligiousInfo {}

export interface FamilyHistory {
  familyHistory_1_1: string;
  familyHistory_1_2: string;
  familyHistory_2_2: string;
  familyHistory_2_1: string;
  familyHistory_3_1: string;
  familyHistory_3_2: string;
  familyHistory_4_2: string;
  familyHistory_4_1: string;
  familyHistory_5_2: string;
  familyHistory_5_1: string;
  familyHistory_6_1: string;
  familyHistory_6_2: string;
  familyHistory_7_2: string;
  familyHistory_7_1: string;
  familyHistory_8_1: string;
  familyHistory_8_2: string;
  familyHistory_9_1: string;
  familyHistory_9_2: string;
  familyHistory_10_1: string;
  familyHistory_10_2: string;
  familyHistory_11_1: string;
  familyHistory_11_2: string;
}

export interface HealthInfo {
  healthInfo_1: string;
  healthInfo_2: string;
  healthInfo_3: string;
  healthInfo_4: string;
  healthInfo_5: string;
  healthInfo_6: string;
  healthInfo_7: string;
  healthInfo_8: string;
  healthInfo_9: string;
  healthInfo_10: number;
  healthInfo_11: string;
  healthInfo_12: string;
  healthInfo_13: string;
  healthInfo_14: string;
}

export interface OtherInfo {
  otherInfo_1: string;
  otherInfo_2: string;
  otherInfo_3: string;
  otherInfo_4: string;
  otherInfo_5: string;
}

export interface IntakeForm {
  updatedAt: string;
  isCompleted: boolean;
  treatmentHistory: TreatmentHistory;
  mentalHealthHistory: MentalHealthHistory;
  socialHistory: SocialHistory;
  legalHistory: LegalHistory;
  educationalHistory: EducationalHistory;
  occupationalInfo: OccupationalInfo;
  religiousInfo: ReligiousInfo;
  familyHistory: FamilyHistory;
  healthInfo: HealthInfo;
  otherInfo: OtherInfo;
}
